"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'microphone.access.denied': 'Acceso al micrófono denegado. Por favor permite el acceso al micrófono para usar las funciones de voz.',
};
